import {
    Box,
    Container,
    Grid,
    Skeleton,
    Stack,
    styled,
    SwipeableDrawer,
    TextField,
    Typography,
    IconButton,
    Button,
    CircularProgress,
    Divider,
    Card,
    CardMedia,
    Modal,
    Autocomplete,
    Snackbar,
} from "@mui/material";
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import React, { useState } from "react";
import { UserAuth } from "../context/AuthContext";
import { db, functions } from "../firebase.config";
import CustomButton from "../Components/CustomButton";
import EventCard from "../Components/EventCard";
import Iconify from "../Components/Iconify";
import { sendPasswordResetEmail } from "firebase/auth";
import { Facebook, Google } from "@mui/icons-material";
import { Variables } from "../context/VariableContext";
import CustomTextField from "../Components/CustomTextField";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import Historique from "./Paie/historique";
import Coordonnées from "./Paie/coordonnee";
import { httpsCallable } from "firebase/functions";

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'white',
    border: '1px solid white',
    borderRadius: '7px',
    boxShadow: 0,
    '@media (max-width: 700px)': {
        width: '90%', // Redimensionne sur mobile
    },
};

const Paie = ({ open, count }) => {
    const { user } = UserAuth();
    const navigate = useNavigate()
    const { openLogin, setOpenLogin, refresh } = Variables();
    const [loading, setLoading] = React.useState(false);
    const [events, setEvents] = React.useState([]);
    const [affilliationData, setAffiliationData] = React.useState();



    const goToEvent = (index) => {
        navigate(`/affiliation/${events[index].affId}&${events[index].id}`)
    };

    const [openConnexion, setOpenConnexion] = React.useState(open);
    const [menu, setMenu] = React.useState(0);

    const [openDemandeModal, setOpenDemandeModal] = React.useState(false);
    const [montant, setMontant] = React.useState();
    const handleOpenDemandeModal = async () => {
        setOpenDemandeModal(true);

    };

    // create affiliation
    const createRequest = async () => {
        try {
            // Appel à la fonction Cloud pour créer l'affiliation
            setLoading(true)
            /* const validate = checkValue()
            if (!validate) {
              setLoading(false)
              setMsg({error: true,content: 'Erreur lors de la création de l’affiliation'})
              setOpenSnack(true)
              return  
            } */ 
            const createAffiliationFunction = httpsCallable(functions, 'addAffiliateRequestPayment');

            const response = await createAffiliationFunction({
                partnerId: user.uid,
                affid: SelectedEvent.affid,
                eventId: SelectedEvent.info.id,
                event: SelectedEvent.info.data().nomEvent,
                valueRequested: parseInt(montant),
            });
            
            // console.log('Affiliation créée avec succès:', response.data);
            // setMsg({error: false,content: 'Affiliation créée avec succès'})
            // setOpenSnack(true)
            // navigate(-1)
            setMsg({ content: 'Demande effectuée', color: 'green' });
            setOpenSnack(true);
            handleCloseDemandeModal()
        } catch (error) {
            // setMsg({error: true,content: 'Erreur lors de la création de l’affiliation'})
            // setOpenSnack(true)
            console.error('Erreur lors de la création de l’affiliation:', error);
            setMsg({ content: 'Une erreur s\'est produite lors de votre demande', color: 'red' });
            setOpenSnack(true);
        }
        setLoading(false)
    };
    const handleCloseDemandeModal = () => setOpenDemandeModal(false);

    const [SelectedEvent, setSelectedEvent] = React.useState();
    const handleEventSelect = async (selectedEvent) => {
        try {
            const affRef = doc(db, `evenement/${selectedEvent.info.id}/affiliations/`, `${selectedEvent.affid}`);
            const affSnap = await getDoc(affRef)
            if (affSnap.exists()) {
                setAffiliationData(affSnap)
                console.log(affSnap.data())
            }
            else {
                console.log('evenent non trouve')
            }
        } catch (error) {
            console.error(error)
        }
        setSelectedEvent(selectedEvent)
        // Faire quelque chose avec l'événement sélectionné (ex: le sauvegarder dans la campagne)
    };

    //  snack bar
  const [openSnack, setOpenSnack] = React.useState(false);
  const [msg, setMsg] = React.useState({ content: '', color: '' });
  const handleCloseSnack = () => {
    setOpenSnack(false);
  };

    React.useEffect(() => {
        (async () => {
            try {
                setEvents([])
                const q = query(collection(db, `partners/${user.uid}/affiliations`));
                const snapshot = await getDocs(q);
                snapshot.forEach(async (d) => {
                    const q1 = doc(db, `evenement`, d.id);
                    const snapshotevent = await getDoc(q1);
                    if (snapshotevent.exists()) {
                        setEvents((events) => [...events, { affid: d.data().affId, info: snapshotevent }]);
                    }
                });
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        })();
    }, [user, refresh]);


    return (
        <Container>
            <Stack sx={{ color: 'white' }} spacing={3}>
                <Stack spacing={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                        <CustomButton type='primaire' buttonText='Demander un paiement' onClick={handleOpenDemandeModal} />
                        <Modal
                            open={openDemandeModal}
                            onClose={handleCloseDemandeModal}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            sx={{ borderRadius: '7px' }}
                        >
                            <Box sx={styleModal}>
                                <Box padding={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Typography variant='subtitle1'>
                                        Nouvelle demande paiement
                                    </Typography>
                                </Box>

                                <Divider />
                                <Stack spacing={3} padding={3} justifyContent='center' alignItems='center'>
                                    <Typography variant='body1'> <strong>Montant disponible : {affilliationData?.data()?.revenueGenerated}</strong></Typography>

                                    {
                                        events.length > 0 ?
                                            <>
                                                <Autocomplete
                                                    fullWidth
                                                    options={events}
                                                    getOptionLabel={(option) => option.info.data().nomEvent}
                                                    value={SelectedEvent}
                                                    renderOption={(props, option) => (
                                                        <Stack direction='row' spacing={1} component="li" {...props} display="flex" alignItems="center">
                                                            <LazyLoadImage
                                                                src={`${option.info.data().idVisuel}`}
                                                                alt={`${option.info.data().idVisuel}`}
                                                                className="img-lazy"
                                                                width={70}
                                                                height={70}
                                                                style={{ objectFit: 'cover' }}
                                                                effect="blur" // opacity | black-and-white
                                                            />
                                                            <Box>
                                                                <Typography variant="subtitle1">{option?.info?.data().nomEvent}</Typography>
                                                                <Typography variant="body2" color="textSecondary">
                                                                    dans 3 jours
                                                                </Typography>
                                                                <Typography variant="body2" color="textSecondary">
                                                                    {option?.info?.data().participant} participants
                                                                </Typography>
                                                            </Box>
                                                        </Stack>
                                                    )}
                                                    renderInput={(params) => <TextField {...params} placeholder="Selectionner un evenement" variant="outlined" />}
                                                    onChange={(_event, value) => handleEventSelect(value)}
                                                    filterOptions={(options, { inputValue }) =>
                                                        options.filter((option) =>
                                                            option?.info?.data().nomEvent.toLowerCase().includes(inputValue.toLowerCase())
                                                        )
                                                    }
                                                />
                                            </>

                                            :
                                            <Box sx={{ padding: 2, bgcolor: '#FFADB0', borderRadius: '10px' }}>
                                                <Typography variant='body2'>Aucun evenement disponible</Typography>
                                            </Box>
                                    }
                                    {
                                        SelectedEvent ? 
                                            <>
                                                <TextField type="number" value={montant} onChange={(e) => setMontant(e.target.value)} fullWidth placeholder='Montant' />
                                            </> : null
                                    }

                                </Stack>

                                <Divider />
                                <Stack direction='row' spacing={2} padding={2} sx={{ display: 'flex', justifyContent: 'right' }}>
                                    <CustomButton type='secondaire' buttonText='fermer' onClick={handleCloseDemandeModal} />
                                    <CustomButton type='primaire' buttonText='Confirmer' onClick={createRequest} />
                                </Stack>
                            </Box>
                        </Modal>
                    </Box>
                    <Stack mb={4} direction='row' spacing={1}>
                        <Box onClick={() => setMenu(0)} sx={menu === 0 ? { bgcolor: '#5E17EB', borderRadius: '30px', cursor: 'pointer' }
                            :
                            { bgcolor: '#292929', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                            <Typography variant='body2'>Historique de paiement</Typography>
                        </Box>
                        <Box onClick={() => setMenu(1)} sx={menu === 1 ? { bgcolor: '#5E17EB', borderRadius: '30px', cursor: 'pointer' }
                            :
                            { bgcolor: '#292929', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1.25} >
                            <Typography variant='body2'>Coordonnée de paiement</Typography>
                        </Box>
                    </Stack>
                    {
                        menu === 0 ?
                            <Historique />
                            :
                            <Coordonnées />
                    }


                </Stack>

            </Stack>
            <Snackbar
        open={openSnack}
        autoHideDuration={5000}
        onClose={handleCloseSnack}
        message={
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography paddingRight={1} variant='body2'>{msg.content}{' '}</Typography>
            <Iconify
              sx={{ color: msg.color }}
              icon={`${msg.red ? 'system-uicons:cross-circle' : 'mdi:success-circle-outline'}`}
            />
          </Box>
        }
      />
        </Container>
    );
};

export default Paie;
